import store from '@/store'

function setRem() {
    var whdef = 100 / 1920;
    var bodyWidth = document.body.clientWidth;
    var rem = bodyWidth * whdef;
	if(rem<=45){
		rem = 45
	}
    document.getElementsByTagName('html')[0].style.fontSize = rem + 'px';
	store.state.user.rem = rem
	//store.state.user.rem = 0
}

setRem()
window.onresize = function () {
    setRem()
}



// WEBPACK FOOTER //
// ./src/utils/rem.js